import { render, staticRenderFns } from "./FieldsetContractLifecycle.yaml?vue&type=template&id=4ad996ff&component"
import script from "./FieldsetContractLifecycle.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractLifecycle.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports